// extracted by mini-css-extract-plugin
module.exports = {"logo-wrap":"logo-wrap__u8Ys4","logoWrap":"logo-wrap__u8Ys4","logo":"logo__1AIB-","description":"description__2gwvo"};